export default __webpack_public_path__ + "2b842a39ddcb7e128086d8fbefb2c192.svg";